import { useContext } from "react";
import globalStates from "../../utils/global";
import "./AppFooter.css"
import { IconEmail, IconInstagram, WebisteLogo } from "../../assets";

const openInNewTab = (url: string) => {
  if (!url.startsWith("http")) {
    url = "https://" + url;
  }
  window.open(url, "_blank", "noopener,noreferrer");
};

const handleEmail = (destination:string) =>{
        const email = destination || 'salesmarketing@naturalhoodspices.com';
        const subject = 'More information about Kuno Cultures';
        const body = 'Hi, I want to know more about Kuno Cultures. Thank you.';

        // Create the mailto link
        const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

        // Create a temporary anchor element to trigger the mail client
        const tempLink = document.createElement('a');
        tempLink.href = mailtoLink;
        tempLink.click();
    }

const AppFooter = () =>{
    const context = globalStates && globalStates.globalContext;
        const globalContext:any = useContext(context);
        const windowWidthClass = globalContext && globalContext.windowWidthClass;

    return (
        <div className={`${windowWidthClass}-app-footer`}>
            <div className="anchor-1 contacts">
                <h3 className="anchor-title">Contact Us</h3>
                {/* <p className="anchor-text"> </p> */}
            </div>
            <div className="anchor-2 social media">
                <div className="frame email">
                    <img src={IconEmail} onClick={()=>handleEmail('hello@kunocultures.com')}/>
                </div>
                <div className="frame instagram">
                    <img src={IconInstagram} onClick={()=>openInNewTab('https://www.instagram.com/kuno.cultures')}  />
                </div>
            </div>
            <div className="anchor-3">
                <div className="frame">
                    <img src={WebisteLogo} />
                </div>
            </div>
        </div>

    )
};

export default AppFooter;